<button class="btn btn-social btn-facebook" type="button" (click)="signInWithFB()">
  <i class="bi bi-facebook"></i>
  Continue with Facebook
</button>
